import React from 'react';
export function Section({
  children,
  className = '',
  id,
  variant = 'default'
}: {
  children: React.ReactNode;
  className?: string;
  id?: string;
  variant?: 'default' | 'alt' | 'upsell';
}) {
  let bgClass = '';
  if (variant === 'alt') bgClass = 'bg-brand-bgAlt';
  if (variant === 'upsell') bgClass = 'bg-brand-upsell text-white';
  return <section id={id} className={bgClass} style={{
    contentVisibility: 'auto',
    containIntrinsicSize: 'auto 500px'
  } as React.CSSProperties} data-id="element-257">
      <div className={`py-16 md:py-24 px-4 ${variant === 'upsell' ? 'max-w-5xl' : 'max-w-4xl'} mx-auto ${className}`} data-id="element-258">
        {children}
      </div>
    </section>;
}